import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "successMessage", "errorMessage", "input", "button", "message", "terms"]

  connect() {
    // Initialize button state
    this.updateButtonState();
    
    // Add event listeners
    this.termsTarget.addEventListener("change", () => this.updateButtonState());
    
    this.formTarget.addEventListener("submit", (event) => {
      event.preventDefault();
      if (this.termsTarget.checked) {
        this.submitForm();
      }
    });
  }

  updateButtonState() {
    this.buttonTarget.disabled = !this.termsTarget.checked;
  }

  async submitForm() {
    if (!this.termsTarget.checked) return;

    const formData = new FormData(this.formTarget)

    // Add UTM parameters if available
    const urlParams = new URLSearchParams(window.location.search)
    formData.append("utm_source", urlParams.get("utm_source") || "")
    formData.append("utm_medium", urlParams.get("utm_medium") || "organic")

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const data = await response.json()
      
      if (response.ok) {
        this.showSuccess()
      } else {
        this.showError(data.error || "An error occurred")
      }
    } catch (error) {
      this.showError("An error occurred. Please try again.")
    }
  }

  showSuccess() {
    this.errorMessageTarget.classList.add("hidden")
    this.messageTarget.classList.remove("hidden")
    this.successMessageTarget.classList.remove("hidden")
    this.inputTarget.value = ""
    this.buttonTarget.disabled = true
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.messageTarget.classList.remove("hidden")
    this.errorMessageTarget.classList.remove("hidden")
    this.inputTarget.value = ""
    this.buttonTarget.disabled = false
  }
}